<div>
  <main class="">
    <router-outlet></router-outlet>
    <!--- Loader --->
    <!-- <app-page-loader *ngIf="loaderService.loading$ | async"></app-page-loader> -->
  </main>
  <app-loader></app-loader>
</div>
